<template>
  <div class="box box-success">
    <div class="box-body">
      <div class="col-md-12">
        <div class="row">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-labeled btn-primary pull-right"
              @click="onAddService"
              style="margin-right: 5px;"
            >
              <span class="btn-label"> <i class="fa fa-plus"></i> </span>
              {{ $t("common.addnew") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="margin-top: 15px">
        <div class="col-sm-12 col-md-4">
          <div class="row">
            <div class="form-group">
              <v-select
                v-if="bookingId"
                class="clear"
                :options="apartmentListInBooking"
                :reduce="data => data.value"
                label="text"
                :getOptionLabel="option => $t(option.text)"
                v-model="apartmentId"
                :placeholder="$t('feedback.apartmentCode')"
                @option:selected="onChangeApartmentInBooking"
              >
                <template v-slot:option="option">
                  {{ option.text }}
                </template>
              </v-select>
              <v-select
                v-else
                class="clear"
                :options="apartmentList"
                :reduce="data => data.value"
                :getOptionLabel="option => $t(option.text)"
                v-model="apartmentId"
                :placeholder="$t('feedback.apartmentCode')"
                @option:selected="onChangeApartment(apartmentId)"
              >
                <template v-slot:option="option">
                  {{ option.text }}
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-4" v-if="bookingId">
          <div class="form-group">
            <span v-if="apartmentInBookingSelect">
              <label for="">{{ $t('apartment.status') }}: </label>
              {{ $t(getApartmentInBookingStatus(apartmentInBookingSelect.status)) }}
            </span>
          </div>
        </div>

        <div>
          <b-table
            striped
            hover
            :items="serviceInApartmentItems"
            :fields="serviceInApartmentFields"
          >
            <template #head()="scope">
              <div class="">{{ $t(scope.label) }}</div>
            </template>
            <template #cell(servicePrice)="row">
              {{ currencyFormat(row.item.servicePrice) }}
            </template>
            <template #cell(totalFee)="row">
              {{ currencyFormat(row.item.totalFee) }}
            </template>
            <template #cell(actions)="row">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-danger dropdown-toggle"
                  data-toggle="dropdown"
                  aria-expanded="true"
                >
                  <i class="fa fa-fw fa-ellipsis-h"></i>
                </button>
                <ul class="dropdown-menu" style="min-width: 50px">
                  <li style="margin-top: 5px">
                    <button
                      v-if="
                        GET_ACCOUNT_DATA.id == 1 || has_perm('delete_service')
                      "
                      class="btn btn-danger btn-sm"
                      style="margin-left: 6px;"
                      @click="onOpenDelete(row.item)"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </template>
          </b-table>
          <div class="box-footer clearfix" style="display:contents;">
            <custom-paginator
              :totalItem="paginateData.totalItem"
              :currentPage="paginateData.currentPage"
              :pageSize="paginateData.pageSize"
              :totalPage="paginateData.totalPage"
              @onpaginate="onCustomPagination"
            />
          </div>
        </div>
      </div>
    </div>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <add-service-in-apartment
      ref="addServiceInApartment"
      :booking-id="bookingId"
      @callbackGetServiceInApartment="callbackGetService"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import CustomPaginator from "@/components/CustomPaginator.vue";
import AddServiceInApartment from "./AddServiceInApartment";

import BookingActionEnum from "@/enum/bookingActionEnum";
import constantsData from "@/lib/constantsData";
import utils from "@/lib/utils";

export default {
  components: {
    "lte-modal": LTEModal,
    CustomPaginator,
    AddServiceInApartment
  },
  props: {
    bookingId: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    apartmentList: [],
    apartmentId: null,
    serviceInApartmentFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "serviceCode",
        label: "service.service_code"
      },
      {
        key: "serviceName",
        label: "service.serviceList.serviceName"
      },
      {
        key: "quantity",
        label: "serviceAndProductInApartment.quantity"
      },
      {
        key: "serviceUnit",
        label: "service.serviceUnit"
      },
      {
        key: "servicePrice",
        label: "product.productList.productPrice"
      },
      {
        key: "totalFee",
        label: "serviceAndProductInApartment.totalFee"
      },
      {
        key: "dateTime",
        label: "serviceAndProductInApartment.dateTime"
      },
      { key: "actions", label: "common.action" }
    ],
    serviceInApartmentItems: [],
    isModalVisible: false,
    originalRecordData: null,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    apartmentListInBooking: [],
    apartmentInBookingSelect: null,
    apartmentBookingStatusList: constantsData.apartmentBookingStatusList,
  }),
  watch: {
    bookingId: function() {},
    GET_APARTMENT_LIST_NO_PAGE_DATA: function() {
      this.apartmentList = [];
      let data = this.GET_APARTMENT_LIST_NO_PAGE_DATA;
      data.forEach(apartment => {
        let item = {
          value: apartment.id,
          text: apartment.apartment_code
        };
        this.apartmentList.push(item);
      });
    },
    GET_SERVICE_IN_APARTMENT_LIST_DATA: function() {
      let paginate = this.GET_SERVICE_IN_APARTMENT_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.serviceInApartmentItems = [];
      this.GET_SERVICE_IN_APARTMENT_LIST_DATA.results.forEach((data, i) => {
        let nonumber =
          i +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          nonumber: nonumber,
          id: data.id,
          serviceCode: data.service.code,
          serviceName: data.service.name,
          quantity: data.amount,
          serviceUnit: data.service.service_unit,
          servicePrice: data.unit_price,
          totalFee: data.total_price,
          dateTime: utils.formatSqlDate(data.start_time, null, "DD/MM/YYYY")
        };
        this.serviceInApartmentItems.push(item);
      });
    },
    GET_APARTMENT_LIST_IN_BOOKING_DATA: function() {
      let data = this.GET_APARTMENT_LIST_IN_BOOKING_DATA;
      this.apartmentListInBooking = [];
      data.forEach(value => {
        let item = {
          value: value.id,
          text: value.apartment_code,
          status: value.booking_status
        };
        this.apartmentListInBooking.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_LIST_NO_PAGE_DATA",
      "GET_SERVICE_IN_APARTMENT_LIST_DATA",
      "GET_APARTMENT_LIST_IN_BOOKING_DATA"
    ])
  },
  methods: {
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onShowError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    onAddService: function() {
      if (utils.isEmptyString(this.apartmentId)) {
        this.onShowError(this.$t("feedback.apartmentCode"));
      } else if (this.bookingId) {
        if (this.apartmentInBookingSelect.status === BookingActionEnum.CHECKED_IN) {
          this.$refs.addServiceInApartment.onShowAddNew(this.apartmentId);
        } 
        else {
          this.onShowError(
            this.$t('serviceAndProductInApartment.errorAddServiceApartmentBookingNotCheckIn')
          )
        }
      } else {
        this.$refs.addServiceInApartment.onShowAddNew(this.apartmentId);
      }
    },
    onViewImgNewTab: function(data) {
      window.open(data);
    },
    onOpenDelete: function(data) {
      this.originalRecordData = data;
      this.isModalVisible = true;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_SERVICE_IN_APARTMENT(this.originalRecordData)
        .then(
          function() {
            this.callbackGetService();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getServiceList: function() {
      this.GET_SERVICE_LIST_V2();
    },
    onCallbackData: async function() {
      await this.getServiceList(1);
      await this.getServiceInApartment(this.apartmentId, 1);
    },
    callbackGetService: function() {
      this.getServiceInApartment(
        this.apartmentId,
        this.paginateData.currentPage
      );
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getServiceInApartment(this.apartmentId, data);
    },
    getServiceInApartment: function(apartmentId, page) {
      let filter = {
        params: {
          apartmentId: apartmentId,
          apartmentBookingId: this.bookingId,
          page: page
        }
      };
      this.GET_SERVICE_IN_APARTMENT_LIST(filter);
    },
    onChangeApartment: function(data) {
      this.getServiceInApartment(data, 1);
    },
    onChangeApartmentInBooking: function(data) {
      this.apartmentInBookingSelect = data
      this.getServiceInApartment(data.value, 1)
    },
    getApartmentInBookingStatus: function(value) {
      let index = this.apartmentBookingStatusList.findIndex(
        x => x.value === value
      );
      return index !== -1 ? this.apartmentBookingStatusList[index].text : null;
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      "GET_SERVICE_LIST_V2",
      "DELETE_SERVICE_IN_APARTMENT",
      "GET_SERVICE_IN_APARTMENT_LIST"
    ])
  },
  async mounted() {
    await this.getServiceList(1);
  }
};
</script>
<style scoped>
.asset-img-class {
  width: 100%;
  max-width: 75px;
  max-height: 100px;
  object-fit: contain;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Product/ServiceInApartment.vue